<template>
  <div class="flex flex-col gap-y-8">
    <JadeBox>
      <div class="flex justify-between px-5 py-5">
        <JadeDisplayItem
          alignment="left"
          :label="$t('amount')"
          :support="$t('created-at', { formattedDate: dateFormated })"
          :value="amount"
        />
        <JadeDisplayItem
          alignment="right"
          :label="$t('status')"
          :value="{ variant: statusVariant, text: statusLabel }"
        />
      </div>
      <div class="px-5">
        <JadeDivider />
      </div>
      <JadeListItem
        :label="$t('chargebackId')"
        :trailing="chargebackId"
      />

      <div class="px-5">
        <JadeDivider />
      </div>
      <JadeListItem
        :label="$t('reasonDescription')"
        :trailing="reasonDescription"
      />

      <div class="px-5">
        <JadeDivider />
      </div>
      <JadeListItem
        :label="$t('customer-name')"
        :trailing="cardHolderName"
      />

      <div class="px-5">
        <JadeDivider />
      </div>
      <JadeListItem
        :label="$t('document-number')"
        :trailing="customerDocument"
      />

      <div class="px-5">
        <JadeDivider />
      </div>
      <JadeListItem
        :label="$t('email')"
        :trailing="email"
      />
      <div class="mb-2"></div>
    </JadeBox>
    <JadeBox>
      <jade-group-header :title="$t('payment-data')" />
      <JadeListItem
        :label="$t('payment-method')"
        :trailing="$t('credit-card')"
      />
      <div class="px-5">
        <JadeDivider />
      </div>
      <JadeListItem :label="$t('card-brand')">
        <template #trailing>
          <jade-brand :use="brandImage" />
        </template>
      </JadeListItem>
      <div class="px-5">
        <JadeDivider />
      </div>
      <JadeListItem
        :label="$t('card-number')"
        :trailing="cardNumber"
      />

      <div class="px-5">
        <JadeDivider />
      </div>
      <JadeListItem
        :label="$t('card-holder-name')"
        :trailing="cardHolderName"
      />
      <div class="mb-2"></div>
    </JadeBox>
  </div>
</template>
<script>
import ChargebackManager from '../chargeback.manager.js'
import {
  JadeListItem,
  JadeBox,
  JadeDisplayItem,
  JadeDivider,
  JadeGroupHeader,
  JadeBrand
} from '@jade'

import DateManager from '@utils/date-manager.utils'

export default {
  name: 'ChargebackDetailsData',
  components: {
    JadeBox,
    JadeDisplayItem,
    JadeDivider,
    JadeListItem,
    JadeGroupHeader,
    JadeBrand
  },
  props: {
    transactionId: String,
    createdAt: String,
    statusCode: {
      type: Number,
      required: true
    },
    amount: String,
    customerDocument: String,
    transactionDate: String,
    email: String,
    cardHolderName: String,
    cardFirstDigits: String,
    cardLastDigits: String,
    cardBrand: String,
    cardNumber: String,
    reasonDescription: String,
    chargebackId: [String, Number]
  },
  computed: {
    brandImage () {
      return this.cardBrand.toLowerCase()
    },
    statusVariant () {
      return ChargebackManager.chargebackStatusBadge(this.statusCode)
    },
    statusLabel () {
      return ChargebackManager.chargebackStatusLabel(this.statusCode)
    },
    dateFormated () {
      return DateManager.formatShortDateToLong(
        this.createdAt,
        navigator.language
      )
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "amount": "Valor",
      "status": "Status",
      "createAt": "Criado em:",
      "chargebackId": "Identificador",
      "reasonDescription": "Motivo da contestação",
      "customer-name": "Nome do pagador",
      "document-number": "CPF",
      "email": "E-mail",
      "payment-methods": "Forma de pagamento",
      "card-brand": "Bandeira",
      "card-number": "Número do cartão",
      "card-holder-name": "Nome do portador do cartão",
      "created-at": "Criado em {formattedDate}",
      "payment-method": "Forma de pagamento",
      "credit-card": "Cartão de crédito",
      "payment-data": "Dados do pagamento"
    },
    "en-US" : {
      "amount": "Amount",
      "status": "Status",
      "createAt": "Created at:",
      "chargebackId": "Identifier",
      "reasonDescription": "Chargeback reason",
      "customer-name": "Client name",
      "document-number": "CPF",
      "email": "E-mail",
      "payment-methods": "Payment method",
      "card-brand": "Card brand",
      "card-number": "Card number",
      "card-holder-name": "Card holder name",
      "created-at": "Created at {formattedDate}",
      "payment-method": "Payment method",
      "credit-card": "Credit card",
      "payment-data": "Payment data"
    }
  }
</i18n>
